<div class="card-header">
  <div class="grid-x">
    <div class="cell auto">
      <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{tender.label}}</h4>
    </div>
    <div class="cell shrink">
        <span class="f-10 c-medium-gray padding-r-xs" *ngIf="widget.size === WidgetSize.LARGE && tender.status === TenderStatus.PUBLISHED">
          {{ 'widget.funding-tender.published-description' | translate :{'publicationDate': tender.publicationDate | date: 'dd/MM/yyyy'} }}
        </span>
    </div>
  </div>
</div>

<div class="card-body vertical-center"
      style="overflow: hidden; height: 100%;">
  <div class="d-block padding-h">
      <span class="d-block margin-h-l border-t border-b c-medium-gray"
            style="padding-top: 0.5rem; padding-bottom: 0.5rem"
            *ngIf="widget.size === WidgetSize.SMALL && tender.status === TenderStatus.PUBLISHED">
          {{ 'widget.funding-tender.published-description' | translate :{'publicationDate': tender.publicationDate | date: 'dd/MM/yyyy'} }}
      </span>
    <div class="d-block margin-h-l">
      <div class="grid-x" style="justify-content: center;">
        <div class="auto margin-t">
          <div class="label-scenario margin-reset text-center">
            <ng-container *ngIf="tender.status === TenderStatus.READY_TO_PUBLISH; else published">
              {{'widget.funding-tender.published-not-already-sent-main-text' | translate}}
            </ng-container>
            <ng-template #published>
              {{'widget.funding-tender.published-main-text' | translate}}
            </ng-template>
            <span class="fas fa-check c-success" style="font-size:1rem; margin-left:5px"></span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-block" *ngIf="tender.status === TenderStatus.PUBLISHED">
    <div class="d-block margin-h-l padding-v">
      <div class="grid-x d-block text-center">
        <span *ngFor="let lender of tender.contactedLenders" [title]="lender.label"
              class="i-block margin-r-s" style="border-radius:50%;width: 30px; height: 30px;background-size: cover;"
              [style.background-image]="'url(' + lender.urlLogo + ')'"></span>
      </div>
    </div>
  </div>
</div>

<div class="card-footer">
  <a (click)="actionEvent.emit('widget.funding-tender.published');" [href]="goToFundingTenderPublication()"
     class="button insito">
      <span [title]="'widget.funding-tender.published' | translate">{{'widget.funding-tender.published' | translate}}</span>
  </a>
</div>
